"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Link = require("./Link");

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarSearch = function SidebarSearch(_ref) {
  var _ref$Link = _ref.Link,
      Link = _ref$Link === undefined ? _Link2.default : _ref$Link,
      subreddit = _ref.subreddit;
  return _react2.default.createElement(
    "div",
    { className: "spacer" },
    _react2.default.createElement(
      "form",
      { action: subreddit ? "/r/" + subreddit + "/search" : "/search", id: "search", role: "search", method: "GET" },
      _react2.default.createElement("input", { name: "q", placeholder: "search", tabIndex: 20, type: "text" }),
      _react2.default.createElement("input", { tabIndex: 22, type: "submit", value: "" }),
      _react2.default.createElement(
        "div",
        { className: "infobar", id: "searchexpando" },
        _react2.default.createElement(
          "label",
          null,
          _react2.default.createElement("input", { name: "restrict_sr", tabIndex: 21, type: "checkbox", defaultChecked: true }),
          "limit my search to /r/pics"
        ),
        _react2.default.createElement(
          "div",
          { id: "moresearchinfo" },
          _react2.default.createElement(
            "p",
            null,
            "use the following search parameters to narrow your results:"
          ),
          _react2.default.createElement(
            "dl",
            null,
            _react2.default.createElement(
              "dt",
              null,
              "subreddit:",
              _react2.default.createElement(
                "i",
                null,
                "subreddit"
              )
            ),
            _react2.default.createElement(
              "dd",
              null,
              "find submissions in \"subreddit\""
            ),
            _react2.default.createElement(
              "dt",
              null,
              "author:",
              _react2.default.createElement(
                "i",
                null,
                "username"
              )
            ),
            _react2.default.createElement(
              "dd",
              null,
              "find submissions by \"username\""
            ),
            _react2.default.createElement(
              "dt",
              null,
              "site:",
              _react2.default.createElement(
                "i",
                null,
                "example.com"
              )
            ),
            _react2.default.createElement(
              "dd",
              null,
              "find submissions from \"example.com\""
            ),
            _react2.default.createElement(
              "dt",
              null,
              "url:",
              _react2.default.createElement(
                "i",
                null,
                "text"
              )
            ),
            _react2.default.createElement(
              "dd",
              null,
              "search for \"text\" in url"
            ),
            _react2.default.createElement(
              "dt",
              null,
              "selftext:",
              _react2.default.createElement(
                "i",
                null,
                "text"
              )
            ),
            _react2.default.createElement(
              "dd",
              null,
              "search for \"text\" in self post contents"
            ),
            _react2.default.createElement(
              "dt",
              null,
              "self:yes (or self:no)"
            ),
            _react2.default.createElement(
              "dd",
              null,
              "include (or exclude) self posts"
            ),
            _react2.default.createElement(
              "dt",
              null,
              "nsfw:yes (or nsfw:no)"
            ),
            _react2.default.createElement(
              "dd",
              null,
              "include (or exclude) results marked as NSFW"
            )
          ),
          _react2.default.createElement(
            "p",
            null,
            "e.g. ",
            _react2.default.createElement(
              "code",
              null,
              "subreddit:aww site:imgur.com dog"
            )
          ),
          _react2.default.createElement(
            "p",
            null,
            _react2.default.createElement(
              Link,
              { href: "/wiki/search" },
              "see the search faq for details."
            )
          )
        ),
        _react2.default.createElement(
          "p",
          null,
          _react2.default.createElement(
            Link,
            { href: "/wiki/search", id: "search_showmore" },
            "advanced search: by author, subreddit..."
          )
        )
      )
    )
  );
};

exports.default = SidebarSearch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/SidebarSearch.js
// module id = 323
// module chunks = 0